<ejs-tab id="paneView" heightAdjustMode="Fill" [cssClass]="tabCssClass" [animation]="animation" [showCloseButton]="true" 
    (created)="onTabCreated()" 
    (selected)="onTabSelect($event)" 
    (selecting)="onTabSelecting($event)"
    (removing)="onTabRemoving($event)"
    (removed)="onTabRemoved($event)">
</ejs-tab>